import React, { PropsWithChildren } from "react";
import { _goToBack } from "routers/helper";

import {
  View,
  Linking,
  StyleSheet,
  StatusBar as RNStatusBar,
} from "react-native";
import { Button, Img, ScrollLayout, Text } from "components";
import { StatusBar } from "expo-status-bar";

import { colors, sizes, strings } from "assets/constants";
import { logo } from "assets/images";
import css from "styles";

type ITemplate = {
  hideBackButton?: boolean;
  submit?: () => void;
  submitLabel?: string;
  submitLoading?: boolean;
  showHelper?: boolean;
};
export default function EntryScreensForm(props: PropsWithChildren<ITemplate>) {
  const { showHelper, submit, submitLabel, submitLoading, hideBackButton } =
    props;

  const _callToSupport = () => Linking.openURL(`tel:${strings.support_phone}`);

  return (
    <>
      {hideBackButton ? null : (
        <Button
          absolute
          top={10 + RNStatusBar.currentHeight}
          zIndex={10}
          bgColor={colors.transparent}
          onPress={_goToBack}
          square={45}
          icon={{
            size: 23,
            name: "chevron-left",
            color: colors.textColorDark,
          }}
        />
      )}
      <StatusBar backgroundColor={colors.screensBg} style="dark" />

      <ScrollLayout contentContainerStyle={styles.scrollContainer}>
        <View style={{ height: RNStatusBar.currentHeight }} />

        <View style={{ ...css.fitWidth, ...css.centralElements }}>
          <Img
            resizeMode="contain"
            style={styles.logo}
            source={logo.drawerLogo}
          />
          {/* <View>
            <Text size="xxxl" weight="extraBold">
              {strings.management_system}
            </Text>
          </View> */}
        </View>
        <View style={styles.inputsSection}>
          {props.children}

          <Button
            onPress={submit}
            mv={2 * sizes.space}
            loading={submitLoading}
            title={{ value: submitLabel }}
          />

          {showHelper && (
            <View style={{ marginTop: 25 }}>
              <Text weight="bold" align="center">
                {strings.login_helper.title}
              </Text>

              <Text align="center" style={{ lineHeight: 24, marginTop: 5 }}>
                <Text align="center">{strings.login_helper.content_01} </Text>
                <Text
                  align="center"
                  onPress={_callToSupport}
                  weight="extraBold"
                  color={colors.info}
                  style={styles.supportPhone}
                >
                  {strings.support_phone}
                </Text>
                <Text align="center"> {strings.login_helper.content_02}</Text>
              </Text>
            </View>
          )}
        </View>
      </ScrollLayout>
    </>
  );
}

const styles = StyleSheet.create({
  scrollContainer: { alignItems: "center" },

  logo: {
    width: "80%",
    maxWidth: 340,
    aspectRatio: 3.16,
    alignSelf: "center",
    marginTop: 50,
  },

  inputsSection: {
    maxWidth: 400,
    ...css.fitWidth,
    ...css.paddingH,
    ...css.container,
    justifyContent: "center",
  },

  supportPhone: { textDecorationLine: "underline" },
});
